import { render, staticRenderFns } from "./DetailUniqueCampaign.vue?vue&type=template&id=3664565b&scoped=true&"
import script from "./DetailUniqueCampaign.vue?vue&type=script&lang=js&"
export * from "./DetailUniqueCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3664565b",
  null
  
)

export default component.exports